import { render } from "./Sailboat.vue?vue&type=template&id=6da80894"
import script from "./Sailboat.vue?vue&type=script&lang=js"
export * from "./Sailboat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__